import { render } from "./EnrollBirthdayView.vue?vue&type=template&id=7b59b175"
import script from "./EnrollBirthdayView.vue?vue&type=script&lang=js"
export * from "./EnrollBirthdayView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__